export const initValidationMethods = () => {
    $.validator.addMethod('consentRule', function (value, element) {
        const regexData = $(element).data('rule-regex'),
            regexObj = new RegExp(regexData);
    
        if (regexObj.test(value)) {
            return true;
        } else {
            // For optional fields, such as address second line
            if ($(element).attr('aria-required') !== 'true' && $(element).val() === '') {
                $(element).closest('.error').css('display', 'none');
                return true;
            }
            return false;
        };
    }, function (params, element) {
        return '' + $(element).data('msg-regex') + ''
    });

    $.validator.addMethod('organisationName', function (value, element) {
        const selectedValue = $("#Donation_Organisation_OrganisationType").val();
        if ((selectedValue == "Company" || selectedValue == "Group" || selectedValue == "School")) {
            return !(!$('#Donation_Organisation_Name').val());
        } else {
            return true;
        }
    });
    
    $.validator.addMethod("decimalAmountUptoTwoDigits", function (value, element) {
        return this.optional(element) || /^\d+(\.\d{1,2})?$/.test(value);
    }, "Only two decimal places are allowed.");

    $.validator.addMethod(
        "decimal",
        function (value, element) {
            return this.optional(element) || /^[\d. ]+$/.test(value);
        },
        "Please enter a valid amount"
    );
    
    $.validator.addMethod("valueNotEquals", function (value, element, arg) {
        return arg != value;
    }, "Value must not equal arg.");
    
    $.validator.addMethod(
        "postcode",
        function (value, element) {
            const val = value.toUpperCase();
            return this.optional(element) || /^(GIR 0AA|[A-PR-UWYZ](\d{1,2}|([A-HK-Y]\d|[A-HK-Y]\d(\d|[ABEHMNPRV-Y]))|\d[A-HJKS-UW])( |)\d[ABD-HJLNP-UW-Z]{2})$/.test(val);
        },
        "Postcode is invalid"
    );
    
    $.validator.addMethod(
        "phoneNumber",
        function (value, element) {
            return this.optional(element) || /^[0-9+() ]+( ext ?)?\d+$/.test(value);
        },
        "Phone number is invalid"
    );
    
    $.validator.addMethod("isNameFormat",
        function (value, element) {
            const re = /^[A-Za-zÀ-ÿ'\- ]+$/;
            return this.optional(element) || re.test(value);
        }
    );
    
    $.validator.addMethod("isTownFormat",
        function (value, element) {
            const re = /^[A-Za-z'.\-& ]+$/;
            return this.optional(element) || re.test(value);
        }
    );
    
    $.validator.addMethod("isAddressFormat",
        function (value, element) {
            const re = /^[0-9A-Za-z',.;\-&/ ]+$/;
            return this.optional(element) || re.test(value);
        }
    );

    $.validator.addMethod("isAddressSelectionAttempted",
        function (value, element) {
            return this.optional(element) || element.value === "true";  
        }
    );
}